import { render, staticRenderFns } from "./FranchiseesView.vue?vue&type=template&id=c609aa00&scoped=true"
import script from "./FranchiseesView.vue?vue&type=script&lang=ts"
export * from "./FranchiseesView.vue?vue&type=script&lang=ts"
import style0 from "./FranchiseesView.vue?vue&type=style&index=0&id=c609aa00&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c609aa00",
  null
  
)

export default component.exports